export default __webpack_public_path__ + "static/media/Dogs.c1e053ee.png";